import { render } from "./HelpInfo.vue?vue&type=template&id=2be29980"
import script from "./HelpInfo.vue?vue&type=script&lang=js"
export * from "./HelpInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__